export default "__VITE_ASSET__BobjrUmM__"